import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/resync/${number | ':jobId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/resync/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/resync/${jobId}`;
